import { render, staticRenderFns } from "./EducationInfoEdit.vue?vue&type=template&id=6cb4a236"
import script from "./EducationInfoEdit.vue?vue&type=script&lang=js"
export * from "./EducationInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports